import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '@/context/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';

import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ClassesPage from '@/pages/ClassesPage';
import ContactPage from '@/pages/ContactPage';
import PlanningPage from '@/pages/PlanningPage';
import TarifsPage from '@/pages/TarifsPage';
import ProgrammeDetailPage from '@/pages/ProgrammeDetailPage';
import CityLandingPage from '@/pages/CityLandingPage';
import GuideCrossFitPage from '@/pages/GuideCrossFitPage';
import CrossFitDebutantPage from '@/pages/CrossFitDebutantPage';
import BlogListPage from '@/pages/BlogListPage';
import BlogPostPage from '@/pages/BlogPostPage';
import ReservationPage from '@/pages/ReservationPage';
import ZonesPage from '@/pages/ZonesPage';
import ProgramCityPage from '@/pages/ProgramCityPage';
import MentionsLegalesPage from '@/pages/MentionsLegalesPage';
import ConfidentialitePage from '@/pages/ConfidentialitePage';
import BoutiquePage from '@/pages/BoutiquePage';

import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage';
import AdminAnalyticsPage from '@/pages/admin/AdminAnalyticsPage';
import AdminContactsPage from '@/pages/admin/AdminContactsPage';
import AdminBlogListPage from '@/pages/admin/AdminBlogListPage';
import AdminBlogEditorPage from '@/pages/admin/AdminBlogEditorPage';
import AdminPricingPage from '@/pages/admin/AdminPricingPage';
import AdminContentPage from '@/pages/admin/AdminContentPage';
import AdminSeoPage from '@/pages/admin/AdminSeoPage';
import NotFoundPage from '@/pages/NotFoundPage';

import ScrollToTop from '@/components/ScrollToTop';
import { PageviewTracker } from '@/components/PageviewTracker';
import { Toaster } from '@/components/ui/sonner';
import { SiteWideSchema } from '@/components/PageMeta';
import { StickyMobileCTA } from '@/components/StickyMobileCTA';
import { ExitIntentModal } from '@/components/ExitIntentModal';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App overflow-x-hidden">
          <BrowserRouter>
            <ScrollToTop />
            <PageviewTracker />
            <SiteWideSchema />
            <Routes>
              {/* Public */}
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/programmes" element={<ClassesPage />} />
              <Route path="/programmes/:slug" element={<ProgrammeDetailPage />} />
              <Route path="/planning" element={<PlanningPage />} />
              <Route path="/reservation" element={<ReservationPage />} />
              <Route path="/zones-desservies" element={<ZonesPage />} />
              <Route path="/tarifs" element={<TarifsPage />} />
              <Route path="/abonnements-en-ligne" element={<BoutiquePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogListPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/crossfit/:citySlug" element={<CityLandingPage />} />
              <Route path="/cours/:programSlug/:citySlug" element={<ProgramCityPage />} />
              <Route path="/guide-crossfit" element={<GuideCrossFitPage />} />
              <Route path="/crossfit-debutant" element={<CrossFitDebutantPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/confidentialite" element={<ConfidentialitePage />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
              <Route path="/admin/analytics" element={<ProtectedRoute><AdminAnalyticsPage /></ProtectedRoute>} />
              <Route path="/admin/seo" element={<ProtectedRoute><AdminSeoPage /></ProtectedRoute>} />
              <Route path="/admin/demandes" element={<ProtectedRoute><AdminContactsPage /></ProtectedRoute>} />
              <Route path="/admin/blog" element={<ProtectedRoute><AdminBlogListPage /></ProtectedRoute>} />
              <Route path="/admin/blog/new" element={<ProtectedRoute><AdminBlogEditorPage /></ProtectedRoute>} />
              <Route path="/admin/blog/edit/:slug" element={<ProtectedRoute><AdminBlogEditorPage /></ProtectedRoute>} />
              <Route path="/admin/pricing" element={<ProtectedRoute><AdminPricingPage /></ProtectedRoute>} />
              <Route path="/admin/content" element={<ProtectedRoute><AdminContentPage /></ProtectedRoute>} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <StickyMobileCTA />
            <ExitIntentModal />
          </BrowserRouter>
          <Toaster />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
